// extracted by mini-css-extract-plugin
export default {"dialogTitle":"dialog_dialogTitle__pC4jk","close":"dialog_close__nREKU","dialogueContent":"dialog_dialogueContent__f2jCy"};